<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert"/>
      SP Upload数据管理
    </p>
    <template slot="extra">
      <router-link to="/inv/inv" slot="extra">构建报表</router-link> &nbsp; &nbsp;
    </template>
    <Row>
      <Col span="24">
      <Select v-model="query.category" placeholder="请选择Category" class="public-inp">
        <Option
          v-for="item in categoryList"
          :value="item.category"
          :key="item.category"
        >{{item.category}}
        </Option>
      </Select>
      <Select v-model="query.shortName" placeholder="请选择ShortName" class="public-inp">
        <Option
          v-for="item in shortNameList"
          :value="item.shortName"
          :key="item.shortName"
        >{{item.shortName}}
        </Option>
      </Select>
      <Select v-model="query.year" placeholder="请选择统计年份" class="public-inp">
        <Option
          v-for="item in yearList"
          :value="item"
          :key="item"
        >{{item}}
        </Option>
      </Select>
      <Select v-model="query.month" placeholder="请选择统计月份" class="public-inp">
        <Option
          v-for="item in monthList"
          :value="item"
          :key="item"
        >{{item}}
        </Option>
      </Select>
      <Button type="primary" icon="md-upload" class="public-fr" @click="upload()">上传文件
      </Button>
      <!--      <Button type="primary" icon="md-add" class="public-fr" @click="stockImport()">初始化期初|期末库存</Button>-->
      <Button class="public-fr" @click="reset()" v-access="'inv.actual.reset'">重置</Button>
      <Button class="public-fr" type="primary" icon="ios-search" @click="getList()" v-access="'inv.actual.query'">查询</Button>
      </Col>
      <Col span="24">
      <Table
        :style="{marginTop:'10px'}"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="tbList">
        <template slot-scope="{ row,index }" slot="sort">
          <span v-show="false">{{row.code}}</span>
          {{index+1}}
        </template>
        <template slot-scope="{ row}" slot="action">
          <a href="javascript:;" @click="editFn(row)">编辑</a>
        </template>
        <template slot-scope="{ row }" slot="status">
          <i-switch
            :value="row.status == 1"
            :before-change="beforeStateChange"
            @on-change="stateChange(row, $event)"
          />
        </template>
      </Table>
      <Page
        :style="{ float: 'right', marginTop: '10px' }"
        :total="total"
        show-sizer
        show-total
        prev-text="上一页"
        next-text="下一页"
        show-elevator
        @on-change="pageNumChange"
        @on-page-size-change="pageSizeChange"
      />
      </Col>
    </Row>
  </Card>
</template>
<script>
  import columns from '@/views/task/columns';

  export default {
    data() {
      return {
        visiable: false,
        open: false,
        query: {
          page: 1,
          rows: 10,
          category: "",
          shortName: "",
          year: "",
          month: "",
        },
        columns: [{
          title: 'id',
          key: 'id',
          width: 90,
          fixed: 'left'
        }, {
          title: '年/月',
          key: 'year',
          width: 85,
          render: (h, params) => {
            let name = params.row.year + "/" + params.row.month;
            return h("div", name);
          }
        },
          {
            title: 'type',
            key: 'reportType',
            width: 120
          }, {
            title: 'category',
            key: 'category',
            width: 120
          }, {
            title: 'shortName',
            key: 'shortName',
            width: 120
          }, {
            title: '数量',
            key: 'inv',
            width: 100
          }, {
            title: '报表日期',
            key: 'reportDate',
            width: 160
          }, {
            title: '创建时间',
            key: 'createtime',
            width: 160,
          }, {
            title: '更新时间',
            key: 'updatetime',
            width: 160,
            fixed: 'right'
          }],
        tbList: [],
        loading: false,
        total: 0,
        yearList: [2020, 2021, 2022, 2023, 2024, 2025, 2026],
        monthList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        isDisabled: false,
        categoryList: [],
        shortNameList: [],
      }
    },
    created() {
      this.getList();
      this.getCategoryList();
      this.getShortNameList();
    },
    methods: {
      getCategoryList() {
        this.$api.getInvReportCategoryList({}).then(res => {
          if (res.code == '200') {
            this.categoryList = res.data;
          }
        })
      },
      getShortNameList() {
        this.$api.getInvReportShortNameList({}).then(res => {
          if (res.code == '200') {
            this.shortNameList = res.data;
          }
        })
      },
      getList() {
        let data = this.query;
        this.loading = true;
        this.$api.getActualPartReportList(data).then(res => {
          this.loading = false;
          if (res.code == '200') {
            this.tbList = res.data;
            this.total = res.total;
          }
        })
      },
      reset() {
        this.query.category = "";
        this.query.shortName = "";
        this.query.year = "";
        this.query.month = "";
        this.$nextTick(() => {
          this.getList();
        })
      },
      uploadToggle() {
        this.visiable = !this.visiable
      },
      // 页码
      pageNumChange(pageNum) {
        this.query.page = pageNum;
        this.getList();
      },
      // 页数
      pageSizeChange(pageSize) {
        this.query.rows = pageSize;
        // 页码变动触发pageNumChange
        if (this.query.page == 1) {
          this.getList();
        } else {
          this.query.page = 1;
        }
      },
      upload() {
        this.$router.push({
          name: 'actualUpload'
        });
      },
    }
  }
</script>
<style scoped>
  .md5 {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/invreport/actual.vue